// extracted by mini-css-extract-plugin
export default {"barrelThumbnail":"W8ouWW0JlVEuPqVOzyW8","image":"sJ9XG2THn_bPjv2j0RDT"};